module.exports = __webpack_public_path__ + "assets/Rapido.dd9bd06425fe9406352d55e5e4986b50.png";